import $store from '../store'
import { AuthService } from '@/services/auth.service'
import { firstAvailable } from '@/router/util'

/**
 * Current user state initialization
 * @WARN Must be always first in middleware chain
 */
export async function initCurrentUserStateMiddleware(to, from, next) {
  const currentUserId = $store.state.user.currentUser.id

  if (AuthService.getLocalStorageBearer() && !currentUserId) {
    try {
      await $store.dispatch('user/getCurrent')
      next()
    } catch (e) {
      // console.log(e)
    }
  } else {
    next()
  }
}

/**
 * Check access permission to auth routes
 */
export function checkAccessMiddleware(to, from, next) {
  const currentUserId = $store.state.user.currentUser.id
  const isAuthRoute = to.matched.some((item) => item.meta.isAuth)

  if (isAuthRoute && currentUserId) return next()
  if (isAuthRoute)
    return next({
      name: 'login',
      query: {
        redirectFrom: to.fullPath,
      },
    })
  else next()
}

export function checkAbility(to, from, next) {
  const isAuthRoute = to.matched.some((item) => item.meta.isAuth)
  if (!isAuthRoute) return next()

  const abilities = $store.getters['user/definedAbilities']
  const canNavigate = to.matched.some((route) => {
    return abilities.can(route.meta.action || 'read', route.meta.resource)
  })

  if (canNavigate) return next()
  else return next({ path: '/notfound' })
}

/**
 * Check access permission to public routes
 */
export function checkPublicRouteMiddleware(to, from, next) {
  const currentUserId = $store.state.user.currentUser.id
  const isPublicRoute = to.matched.some((item) => !item.meta.isAuth)

  if (!to.name) return next()
  if (isPublicRoute && currentUserId) return next({ name: firstAvailable() })
  else next()
}
